import { actionConstants } from '../constants';
import {
  successReqActionType,
  failReqActionType,
  startReqActionType
} from 'helper/requestHelper';

const initialState = {
  error: null,
  submitError: '',

  paginatedWorkflows: [],
  isLoadingWorkflows: false,
  lastEvaluatedKeys: null,
  totalCount: 0,

  isLoadingWorkflow: false,
  currentWorkflow: null
};

const workflowReducer = (state = initialState, action) => {
  switch (action.type) {
    case startReqActionType(actionConstants.PAGINATED_LIST_WORKFLOW):
      return {
        ...state,
        isLoadingWorkflows: true
      };

    case successReqActionType(actionConstants.PAGINATED_LIST_WORKFLOW):
      return {
        ...state,
        isLoadingWorkflows: false,
        paginatedWorkflows: action.payload.reset
          ? action.payload.data
          : [...state.paginatedWorkflows, ...action.payload.data],
        lastEvaluatedKeys: action.payload.last_evaluated_key,
        totalCount: action.payload.reset
          ? action.payload.total_count
          : state.totalCount
      };
    case failReqActionType(actionConstants.PAGINATED_LIST_WORKFLOW):
      return {
        ...state,
        isLoadingWorkflows: false
      };

    // case successReqActionType(actionConstants.UPDATE_MEDIA):
    //   return {
    //     ...state,
    //     allMedia: {
    //       ...state.allMedia,
    //       [action.payload.id]: {
    //         ...state.allMedia[action.payload.id],
    //         ...action.payload
    //       }
    //     }
    //   };
    case startReqActionType(actionConstants.GET_WORKFLOW_DETAIL):
      return {
        ...state,
        isLoadingWorkflow: true
      };
    case successReqActionType(actionConstants.GET_WORKFLOW_DETAIL):
      return {
        ...state,
        isLoadingWorkflow: false,
        currentWorkflow: action.payload
      };
    case failReqActionType(actionConstants.GET_WORKFLOW_DETAIL):
      return {
        ...state,
        isLoadingWorkflow: false
      };
    case startReqActionType(actionConstants.DELETE_WORKFLOW):
      return {
        ...state
      };
    case successReqActionType(actionConstants.DELETE_WORKFLOW):
      return {
        ...state,
        paginatedWorkflows: state.paginatedWorkflows.filter(
          w => w.id !== action.payload
        ),
        currentWorkflow:
          state.currentWorkflow && state.currentWorkflow.id === action.payload
            ? null
            : state.currentWorkflow
      };
    case failReqActionType(actionConstants.DELETE_WORKFLOW):
      return {
        ...state
      };
    default:
      return state;
  }
};

export default workflowReducer;
